import { format } from "date-fns";
import { enUS, vi } from "date-fns/locale";
import getLocaleInLocal, { BCP47LanguageTag } from "./getLocaleInLocal";

export default function formatDate(
    dateString: string,
    showHour = true,
    type?: "dd-mm" | "hh-mm" | "mm-dd" | "mm-dd-hh-mm"
) {
    const { bcp47locale, localeInDateFns, formatInDateFns } = getLocaleInLocal();
    try {
        const timestamp = Date.parse(dateString);
        const date = new Date(timestamp);
        if (type === "dd-mm") {
            return date.toLocaleDateString(bcp47locale, {
                day: "2-digit",
                month: "2-digit",
            });
        }
        if (type === "mm-dd") {
            return date.toLocaleDateString(bcp47locale, {
                month: "short",
                day: "2-digit",
            });
        }
        if (type === "hh-mm") {
            return date.toLocaleTimeString(bcp47locale, {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            });
        }
        if (type === "mm-dd-hh-mm") {
            return date.toLocaleTimeString(bcp47locale, {
                month: "short",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            });
        }

        if (showHour) {
            const dateString = format(date, formatInDateFns, {
                locale: localeInDateFns,
            });
            return dateString;
        } else {
            return date.toLocaleDateString(bcp47locale, {
                year: "numeric",
                month: "short",
                day: "numeric",
            });
        }
    } catch (err) {
        console.error(err);
        return "--";
    }
}

export function isValidDate(dateString: string) {
    const date = new Date(dateString);
    return date instanceof Date && !isNaN(date.getTime());
}

export function convertISOToMMDDYYYY(isoString: string) {
    const date = new Date(isoString);
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
}
